module.exports = __webpack_public_path__ + "static/media/fun10.4b3d4466.png";